<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.addDistrbutionPoint") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 class="mt-5 font-weight-bold">
            {{ $t("PLACEHOLDERS.distrbution_point_data") }}
          </h5>

          <!-- Start:: Distribution Point Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.distrbution_point_name')"
            v-model.trim="data.name"
            required
          />
          <!-- End:: Distribution Point Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="distrbution_point_image"
            :placeholder="$t('PLACEHOLDERS.user_image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Username Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.username')"
            v-model.trim="data.distrbution_point_name"
            required
          />
          <!-- End:: Username Input -->

          <!-- Start:: Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
            v-model.trim="data.commercial_registration_number"
            required
          />
          <!-- End:: Commercial Registration Number -->

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            required
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Account Status Switch -->
          <!-- <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div> -->
          <!-- End:: Account Status Switch -->

          <!-- Start:: Location Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">
            {{ $t("PLACEHOLDERS.location_on_map") }}
          </h5>

          <!-- Start:: Map Search Input -->
          <div class="col-12 mb-3">
            <input
              ref="searchInput"
              type="text"
              class="form-control"
              :placeholder="
                $t('PLACEHOLDERS.search_location') || 'Search for a location...'
              "
              style="
                padding: 12px;
                border: 1px solid #ddd;
                border-radius: 4px;
                width: 100%;
              "
            />
          </div>
          <!-- End:: Map Search Input -->

          <!-- Start:: Google Map -->
          <div class="col-12 mb-4">
            <ChangableMapComponent
              :lat="parseFloat(data.lat)"
              :lng="parseFloat(data.lng)"
              @update:lat="data.lat = $event"
              @update:lng="data.lng = $event"
            />
          </div>
          <!-- End:: Google Map -->

          <!-- Start:: Address Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.address') || 'Address'"
            v-model.trim="data.address"
            required
          />
          <!-- End:: Address Input -->
          <!-- End:: Location Details -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChangableMapComponent from "@/components/general/ChangableMapComponent.vue";

export default {
  name: "CreateDistrbutionPoint",

  components: {
    ChangableMapComponent,
  },

  data() {
    return {
      isWaitingRequest: false,
      autocomplete: null,
      autocompleteInitAttempts: 0,
      data: {
        image: {
          path: null,
          file: null,
          storagePath: null,
          url: null,
        },
        name: null,
        distrbution_point_name: null,
        mobile: null,
        password: null,
        passwordConfirmation: null,
        active: true,
        commercial_registration_number: null,
        lat: 24.7136,
        lng: 46.6753,
        address: null,
      },
    };
  },

  computed: {
    // ...mapGetters({
    //   allRoles: "ApiGetsModule/allRoles",
    // }),
  },

  watch: {
    "data.lat"(newLat) {
      if (newLat && this.data.lng) {
        this.getAddressFromLatLng(newLat, this.data.lng);
      }
    },
    "data.lng"(newLng) {
      if (newLng && this.data.lat) {
        this.getAddressFromLatLng(this.data.lat, newLng);
      }
    },
  },

  methods: {
    waitForGoogleMaps() {
      const maxAttempts = 20;

      if (window.google && window.google.maps && this.$refs.searchInput) {
        this.initAutocomplete();
        return;
      }

      if (this.autocompleteInitAttempts >= maxAttempts) {
        return;
      }

      this.autocompleteInitAttempts += 1;
      window.setTimeout(() => {
        this.waitForGoogleMaps();
      }, 250);
    },

    // Initialize Google Places Autocomplete
    initAutocomplete() {
      if (window.google && window.google.maps && this.$refs.searchInput) {
        this.autocomplete = new google.maps.places.Autocomplete(
          this.$refs.searchInput,
          { types: ["geocode"] }
        );

        this.autocomplete.addListener("place_changed", this.onPlaceChanged);
      }
    },

    // Handle place selection from autocomplete
    onPlaceChanged() {
      const place = this.autocomplete.getPlace();

      if (place.geometry) {
        this.data.lat = place.geometry.location.lat();
        this.data.lng = place.geometry.location.lng();
        this.data.address = place.formatted_address;
      }
    },

    // Handle image selection for personal image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Handle location selection from map
    selectLocation(location) {
      this.data.lat = location.lat;
      this.data.lng = location.lng;
      this.getAddressFromLatLng(location.lat, location.lng);
    },

    // Get address from coordinates using reverse geocoding
    getAddressFromLatLng(lat, lng) {
      if (window.google && window.google.maps) {
        const geocoder = new google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK" && results[0]) {
            this.data.address = results[0].formatted_address;
          }
        });
      }
    },

    // Validate form inputs before submission
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    // Submit form data
    async submitForm() {
      const formData = new FormData();

      // Append required fields
      formData.append("name", this.data.name);
      formData.append(
        "distrbution_point_name",
        this.data.distrbution_point_name
      );
      formData.append("mobile", this.data.mobile);
      formData.append("password", this.data.password);
      formData.append("password_confirmation", this.data.passwordConfirmation);
      formData.append(
        "commercial_registration_number",
        this.data.commercial_registration_number
      );
      formData.append("lat", this.data.lat);
      formData.append("lng", this.data.lng);
      formData.append("address", this.data.address);

      // Append avatar if provided
      if (this.data.image.storagePath) {
        formData.append("avatar", this.data.image.storagePath);
      }

      try {
        await this.$axios.post("distrbution-points", formData);
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push("/DistrbutionPoints/all");
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  mounted() {
    // Initialize autocomplete after component is mounted
    this.$nextTick(() => {
      this.waitForGoogleMaps();
    });
  },

  created() {
    // Component initialization
  },
};
</script>
